<div class="row">
    <div class="col-md-6 col-xl-3">
        <div class="card card-box mb-5">
            <div class="card-indicator bg-first"></div>
            <div class="card-body px-4 py-3">
                <div class="pb-3 d-flex justify-content-between">
                    <a [routerLink]="">
                        Presentation site UX
                    </a>
                </div>
                <div class="d-flex align-items-center justify-content-start">
                    <div class="badge badge-first px-3">On hold</div>
                    <div class="font-size-sm text-danger px-2">
                        <fa-icon [icon]="['far', 'clock']" class="mr-1"></fa-icon>
                        14:22
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-6 col-xl-3">
        <div class="card card-box mb-5">
            <div class="card-indicator bg-info"></div>
            <div class="card-body px-4 py-3">
                <div class="pb-3 d-flex justify-content-between">
                    <a [routerLink]="">
                        Implement in Vuejs
                    </a>
                </div>
                <div class="d-flex align-items-center justify-content-start">
                    <div class="badge badge-info px-3">Processed</div>
                    <div class="font-size-sm text-dark px-2">
                        <fa-icon [icon]="['far', 'clock']" class="mr-1"></fa-icon>
                        17:56
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-6 col-xl-3">
        <div class="card card-box mb-5">
            <div class="card-indicator bg-success"></div>
            <div class="card-body px-4 py-3">
                <div class="pb-3 d-flex justify-content-between">
                    <a [routerLink]="">
                        Create UI mockups
                    </a>
                </div>
                <div class="d-flex align-items-center justify-content-start">
                    <div class="badge badge-success px-3">Fixed</div>
                    <div class="font-size-sm text-dark px-2">
                        <fa-icon [icon]="['far', 'clock']" class="mr-1"></fa-icon>
                        09:41
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-md-6 col-xl-3">
        <div class="card card-box mb-5">
            <div class="card-indicator bg-warning"></div>
            <div class="card-body px-4 py-3">
                <div class="pb-3 d-flex justify-content-between">
                    <a [routerLink]="">
                        UX research
                    </a>
                </div>
                <div class="d-flex align-items-center justify-content-start">
                    <div class="badge badge-warning px-3">Scheduled</div>
                    <div class="font-size-sm text-danger px-2">
                        <fa-icon [icon]="['far', 'clock']" class="mr-1"></fa-icon>
                        11:35
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
